import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { Login, UserCompany, FirstAccess, TutorialFirstAccess, ArchivedTutorialsPage } from './pages';
import { App } from './App';
import { Token, useAuth } from './contexts/auth';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      Token() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      )
    }
  />
);

const TutorialRoute = ({ component: Component, ...rest }) => {
  const { isTutorialActive } = useAuth();
  return (
    <Route
      {...rest}
      render={props =>
        !Token() ? (
          <Redirect to={{ pathname: "/", state: { from: props.location } }} />
        ) : isTutorialActive ? (
          <Redirect to="/tutorial-first-access" />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

function Routes() {
  const { tokenReports, isAdm } = useAuth();

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route path="/login" component={Login} />
        <Route path="/first-access" component={FirstAccess} />
        <PrivateRoute path="/tutorial-first-access" component={TutorialFirstAccess} />
        <TutorialRoute path="/window" component={App} />
        <TutorialRoute path="/user-companies" component={UserCompany} />
        <TutorialRoute path="/archived-tutorials" component={ArchivedTutorialsPage} />
        {tokenReports && <TutorialRoute path="/reports/charts/consumption" component={App} />}
        {tokenReports && <TutorialRoute path="/reports/charts/service-time" component={App} />}
        {tokenReports && <TutorialRoute path="/reports/charts/service-time-groups" component={App} />}
        {tokenReports && <TutorialRoute path="/reports/charts/performance" component={App} />}
        {tokenReports && <TutorialRoute path="/reports/teleservice/videocall" component={App} />}
        {tokenReports && <TutorialRoute path="/reports/charts/performance-users" component={App} />}
        {isAdm && <TutorialRoute path="/admin/registers/list" component={App} />}
        {isAdm && <TutorialRoute path="/admin/registers/groups" component={App} />}
        {isAdm && <TutorialRoute path="/admin/registers/holidays" component={App} />}
        {/* {tokenReports && <TutorialRoute path="/reports/users/status" component={App} />} */}
        {tokenReports && <TutorialRoute path="/reports/customer-service/total" component={App} />}
        {tokenReports && <TutorialRoute path="/reports/charts/peakattendance" component={App} />}
        {tokenReports && <TutorialRoute path="/reports/customer-service/time-wait-group" component={App} />}
        {isAdm && <TutorialRoute path="/admin/comments/categories" component={App} />}
        {isAdm && <TutorialRoute path="/admin/tutorials/ViewTutorials" component={App} />}
        <TutorialRoute path="*" component={() => <h1>Page not found</h1>} />
      </Switch>
    </BrowserRouter>
  )
};

export default Routes;